import type { Method } from 'axios'
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios'
import { ServiceUnavailable } from 'common/errors/ServiceUnavailable'

const request = axios.create({
  withCredentials: true,
})

export const pageEditorHttpClient = async <T>(
  url: string,
  method: Method = 'GET',
  options: AxiosRequestConfig<T> = {},
): Promise<T> => {
  try {
    const response: AxiosResponse<T> = await request({
      method,
      url: `/api/dashboard/page-editor/${url}`,
      ...options,
    })
    return response.data
  } catch (error) {
    if (axios.isAxiosError(error) && error.response?.status === 503) {
      throw new ServiceUnavailable(error.response)
    }
    throw error
  }
}
